import React from 'react';
import { observer } from 'mobx-react';
import { CSSTransition } from 'react-transition-group';
import mainStore from '../stores/main';
import globals from '../utils/globals';
import QuestionStep from './steps/question-step/question-step';
import FinalResultStep from './steps/final-result-step/final-result-step';
var StepManager = observer(function (_ref) {
  var settings = _ref.settings,
    isDesktop = _ref.isDesktop;
  var layoutType = isDesktop;
  var handleNextClick = function handleNextClick() {
    window.DGS.Event.getInstance().trigger('trackHearingTestNextStep', mainStore.steps[mainStore.currentStepIndex].StepViewType);
    if (mainStore.nextStepIndex) {
      mainStore.gotoStep(mainStore.nextStepIndex);
    }
  };
  var updatePoints = function updatePoints(_ref2, shouldTriggerPoints) {
    var points = _ref2.points;
    if (shouldTriggerPoints) {
      mainStore.addPoints(points);
    } else {
      mainStore.addPoints(0);
    }
  };
  var stepElement = function stepElement(step) {
    var StepViewType = step.StepViewType,
      Points = step.Points;
    switch (StepViewType) {
      case globals.STEP_TYPE_BUTTON_RESPONSE:
        return /*#__PURE__*/React.createElement(QuestionStep, {
          content: step,
          onNextClick: handleNextClick,
          onUpdatePoints: updatePoints,
          points: Points || mainStore.defaultPoints,
          score: mainStore.points,
          stepsNumber: mainStore.steps.length,
          currentStepIndex: mainStore.currentStepIndex,
          isDesktop: layoutType
        });
      case globals.STEP_TYPE_INFO:
        return /*#__PURE__*/React.createElement(FinalResultStep, {
          content: step,
          onNextClick: handleNextClick,
          score: mainStore.points,
          currentStepIndex: mainStore.currentStepIndex,
          stepsNumber: mainStore.steps.length
        });
      default:
        return /*#__PURE__*/React.createElement("div", null, "Unknown StepViewType: ", StepViewType);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "step-manager"
  }, mainStore.steps.map(function (step, index) {
    return /*#__PURE__*/React.createElement(CSSTransition, {
      in: index === mainStore.currentStepIndex,
      timeout: 0,
      classNames: "step",
      unmountOnExit: true,
      key: step.Id
    }, stepElement(step));
  }));
});
export default StepManager;